import PropTypes from 'prop-types';

const { shape, string } = PropTypes;

export default shape({
  type: string,
  message: string,
  id: string,
});
